import useModalCalendarForm from "hooks/useModalCalendarForm";
import { ComposedModal, ModalHeader } from "carbon-components-react";
import CalendarForm from "forms/CalendarForm/CalendarForm";
import { useParams } from "react-router-dom";
import { ON_DEMAND_EVENT, LIVE_EVENT, ONLINE, SUBSCRIPTION, EVALUATION } from "api/config/calendarTypes";

const ModalEventCalendar = (props) => {

    const event = useParams()

    const {
        selectedCalendar,
        createNewCalendar,
        calendarType,
        modalIsOpen,
        calendarParentId,
        calendarFormOnSubmit,
        closeCalendarForm
    } = useModalCalendarForm()

    const close = () => {
        closeCalendarForm()
        if (calendarFormOnSubmit) {
            calendarFormOnSubmit()
        }
    }
    const form = (calendarType) ? (
        <>
            <CalendarForm
                event={event}
                modal={true}
                onRequestClose={close}
                calendarType={calendarType}
                onSubmit={close}
                hasForm={true}
                itemId={selectedCalendar?.id}
                parentId={calendarParentId}
                createNewCalendar={createNewCalendar}
                selectedCalendar={selectedCalendar}
            />
        </>
    ) : null

    let title = null

    switch (calendarType) {
        case EVALUATION:
            title = "Evaluation open"
            break
        case SUBSCRIPTION:
            title = "Subscriptions open"
            break
        case ONLINE:
            title = "Website is online"
            break
        case LIVE_EVENT:
            title = "LIVE Event"
            break
        case ON_DEMAND_EVENT:
            title = "VOD Event"
            break
    }

    return (
        <ComposedModal
            // buttonTriggerText="Launch modal"
            // modalHeading="Modal heading"
            // className="media-gallery-modal"
            // passiveModal
            size='sm'
            open={modalIsOpen}
            // modalLabel="Media gallery"

            onClose={closeCalendarForm}
        >
            <ModalHeader
                title={title}
                buttonOnClick={closeCalendarForm} />
            {form}
        </ComposedModal>
    )
}

export default ModalEventCalendar